import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { Translation } from '../models/localisation/Translation';
import { EnvironmentService } from './environment.service';
import { UiService } from './ui.service';
import { catchError, switchAll, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LocalisationService {

    public translationsLoaded$ = new BehaviorSubject<boolean>(false);

    public get translationsLoaded(): boolean {
        return this.translationsLoaded$.value;
    }

    public set translationsLoaded(newVal: boolean) {
        this.translationsLoaded$.next(newVal);
    }

    private selectedLanguageId = 1;
    public translations: Translation[];

    constructor(private http: HttpClient,
                private envService: EnvironmentService) {
    }

    private getAllTranslationsForCurrentLanguage(): Observable<Translation[]> {
        this.translationsLoaded = false;
        return this.http
            .get<Translation[]>(`${this.envService.contentHost}/v1/localisation/${this.selectedLanguageId}`);
    }

    public getTranslation(slug: string, ...args: string[]): Observable<string> {
        return this.translationsLoaded$
            .pipe(switchMap((loaded: boolean) => {
                if (!loaded) {
                    return of('');
                }

                const translation = this.translations?.find(tr => tr.stringSlug === slug);
                if (translation) {

                    if (translation.requiresTranslation) {
                        return of(translation.fallBackLanguageTranslation.text ?? '');
                    }

                    if (args && args.length > 0) {
                        for (let i = 0; i < args.length; i++) {
                            const replace = `\\|${i}`;
                            const regex = new RegExp(replace, 'gi');
                            translation.text = translation.text.replace(regex, args[i]);
                        }
                    }

                    return of(translation.text);
                }
                return of('[]' + slug);
            }));
    }

    public async refreshTranslations(): Promise<void> {
        this.translations = await this.getAllTranslationsForCurrentLanguage().toPromise();
        this.translationsLoaded = true;
    }
}
